import { all, takeLatest } from 'redux-saga/effects';

// Import action creators
import {
  loginReq,
  sendOtpReq,
  getCityDataReq,
  verifyEmailOrMobileReq,
  signUpReq,
  switchAccountReq,
  customerInfoReq,
} from '../ducks/AuthSlice';

import {
  getParcelPassengerCitiesReq,
  updateProfileReq,
} from '../ducks/ProfileSlice';

import {
  getVehicleTypeReq,
  getBrandsByVehicleReq,
  getModalByBrandReq,
  vehicleRegistrationReq,
  editVehicleReq,
  vehicleSubTypeReq,
  RatePredictorReq,
  addVehicleReq,
} from '../ducks/VehicleSlice';

import {
  uploadFileReq,
} from '../ducks/AttachmentSlice';

import {
  drivingLicenseReq,
  aadharCardReq,
  panCardReq,
} from '../ducks/DocumentSlice';

import {
  tripUpComingReq,
  completedTripsReq,
} from '../ducks/TripSlice';

import {
  userDetailsReq,
} from '../ducks/UsersSlice';

import {
  searchPlacesReq,
  addressFromLatLongReq,
} from '../ducks/LocationSlice';

import {
  getPlacesReq,
} from '../ducks/PlacesSlice';

import {
  toursReq,
} from '../ducks/ToursSlice';

import {
  driverListOnCallReq,
  getdriverOnCallReq,
  submitRettingReq,
  driverNotificationReq,
} from '../ducks/CustomerOnCallSlice';

import {
  driverOnCallPackageReq,
  drivingOnCallPackageBuyReq,
  customerCallListReq,
} from '../ducks/DriverOnCallSlice';

import {
  getFAQDataReq,
} from '../ducks/CustomerSupport';

// Import handlers
import {
  handlerLoginReq,
  handlerSendOTP,
  handlerGetCity,
  handlerEmailOrMobileVerify,
  handlerSignUpOrRegister,
  handlerSwitchAccount,
  handlerCustomerInfoMe,
} from './handlers/AuthHandler';

import {
  handlerGetParcelPassengerCity,
  handlerUpdateProfile,
} from './handlers/ProfileHandler';

import {
  handlerGetVehicleType,
  handlerGetBrandsByVehicleList,
  handlerGetModalByBrandsList,
  handlerVehicleRegistration,
  handlerEditVehicle,
  handlerVehicleSubType,
  handlerRatePredictor,
  handlerAddVehicle,
} from './handlers/VehicleHandler';

import {
  handlerUploadFile,
} from './handlers/AttachmentHandler';

import {
  handlerDrivingLicenseUpload,
  handlerAadharCard,
  handlerPanCard,
} from './handlers/DocumentHandler';

import {
  handlerTripUpcoming,
  handlerCompletedTrips,
} from './handlers/TripHandler';

import {
  handlerUserDetails,
} from './handlers/UsersHandler';

import {
  handlerGetSearchPlace,
  handlerAddressFromLatLong,
} from './handlers/LocationHandler';

import {
  handlerGetCities,
} from './handlers/PlacesHandler';

import {
  handlerToursReq,
} from './handlers/ToursHandler';

import {
  handlerCustomerOnCallDriverList,
  handlergetdriverOnCall,
  handlerSubmitFeedback,
  handlerDriverNotification,
} from './handlers/CustomerOnCallHandler';

import {
  handlerDriverOnCallPackage,
  handlerOnCallPackageBuUpload,
  handlerCustomerCallDetailList,
} from './handlers/DriverOnCallHandler';

import {
  handlerGetCustomerSupport,
} from './handlers/CustomerSupportHandler';

export default function* rootSaga() {
  yield all([
    // Auth sagas
    takeLatest(loginReq.type, handlerLoginReq),
    takeLatest(sendOtpReq.type, handlerSendOTP),
    takeLatest(getCityDataReq.type, handlerGetCity),
    takeLatest(verifyEmailOrMobileReq.type, handlerEmailOrMobileVerify),
    takeLatest(signUpReq.type, handlerSignUpOrRegister),
    takeLatest(switchAccountReq.type, handlerSwitchAccount),
    takeLatest(customerInfoReq.type, handlerCustomerInfoMe),

    // Profile sagas
    takeLatest(getParcelPassengerCitiesReq.type, handlerGetParcelPassengerCity),
    takeLatest(updateProfileReq.type, handlerUpdateProfile),

    // Vehicle sagas
    takeLatest(getVehicleTypeReq.type, handlerGetVehicleType),
    takeLatest(getBrandsByVehicleReq.type, handlerGetBrandsByVehicleList),
    takeLatest(getModalByBrandReq.type, handlerGetModalByBrandsList),
    takeLatest(vehicleRegistrationReq.type, handlerVehicleRegistration),
    takeLatest(editVehicleReq.type, handlerEditVehicle),
    takeLatest(vehicleSubTypeReq.type, handlerVehicleSubType),
    takeLatest(RatePredictorReq.type, handlerRatePredictor),
    takeLatest(addVehicleReq.type, handlerAddVehicle),

    // Attachment sagas
    takeLatest(uploadFileReq.type, handlerUploadFile),

    // Document sagas
    takeLatest(drivingLicenseReq.type, handlerDrivingLicenseUpload),
    takeLatest(aadharCardReq.type, handlerAadharCard),
    takeLatest(panCardReq.type, handlerPanCard),

    // Trip sagas
    takeLatest(tripUpComingReq.type, handlerTripUpcoming),
    takeLatest(completedTripsReq.type, handlerCompletedTrips),

    // User sagas
    takeLatest(userDetailsReq.type, handlerUserDetails),

    // Location sagas
    takeLatest(searchPlacesReq.type, handlerGetSearchPlace),
    takeLatest(addressFromLatLongReq.type, handlerAddressFromLatLong),

    // Places sagas
    takeLatest(getPlacesReq.type, handlerGetCities),

    // Tours sagas
    takeLatest(toursReq.type, handlerToursReq),

    // Customer On Call sagas
    takeLatest(driverListOnCallReq.type, handlerCustomerOnCallDriverList),
    takeLatest(getdriverOnCallReq.type, handlergetdriverOnCall),
    takeLatest(submitRettingReq.type, handlerSubmitFeedback),
    takeLatest(driverNotificationReq.type, handlerDriverNotification),

    // Driver On Call sagas
    takeLatest(driverOnCallPackageReq.type, handlerDriverOnCallPackage),
    takeLatest(drivingOnCallPackageBuyReq.type, handlerOnCallPackageBuUpload),
    takeLatest(customerCallListReq.type, handlerCustomerCallDetailList),

    // Customer Support sagas
    takeLatest(getFAQDataReq.type, handlerGetCustomerSupport),
  ]);
}
